declare var GLOBAL_EXTENSION_ID: string;
declare var GLOBAL_PRODUCTION: boolean;
declare var GLOBAL_TESTING: boolean;
declare var GLOBAL_UA_STRING: boolean;
declare var GLOBAL_ANALYTICS: boolean;

// This module maps globals injected by Webpack (or from other sources)
// to an accessible module usable by our code.
export class Globals {
  public EXTENSION_ID!: string;
  public EMBEDDED!: boolean;
  public PRODUCTION!: boolean;
  public TESTING!: boolean;
  public UA_STRING!: boolean;
  public ANALYTICS!: boolean;
}

const g: Globals = {
  PRODUCTION: GLOBAL_PRODUCTION,
  EMBEDDED: window.self !== window.top,
  EXTENSION_ID: GLOBAL_EXTENSION_ID,
  TESTING: GLOBAL_TESTING,
  UA_STRING: GLOBAL_UA_STRING,
  ANALYTICS: GLOBAL_ANALYTICS
};

export default g;
